import { find } from 'lodash'
import { createSelector } from 'reselect'

import { areSameValue } from '../../../core/utils'

const selectDishById = createSelector(
  [store => store.dishes.dishes?.data?.result, (state, dishId) => dishId],
  (dishes, dishId) => find(dishes, ({ id }) => areSameValue(id, dishId)),
)

export default selectDishById
